/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import Vacio from './Vacio';

let GoogleMapsReact = require("google-maps-react");
let Map = GoogleMapsReact.Map;
let InfoWindow = GoogleMapsReact.InfoWindow;
let Marker = GoogleMapsReact.Marker;

export default class extends Component {
    constructor(props){
        super(props);
        this.state = {
            poi: {},
            activeMarker: undefined
        };
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onInfoWindowClose = this.onInfoWindowClose.bind(this);
        this.mapReady = this.mapReady.bind(this);
    }

    componentDidMount() {
        this.setState({
            poi: this.props.poi
        });
    }

    onMarkerClick(props, marker, e) {
        this.setState({
            activeMarker: marker,
            showingMarker: true
        })
    }

    onInfoWindowClose() {
        this.setState({
            showingMarker: false
        })
    }

    mapReady(mapProps, map) {
        // console.log(mapProps,map);
    }

    render() {
        if (window.google !== undefined && this.state.poi.latitud && this.state.poi.longitud) {
            let centro = {
                lat: this.state.poi.latitud,
                lng: this.state.poi.longitud
            };
            return (
                <div id="poi-map">
                    <Map google={window.google} zoom={16} initialCenter={centro} onReady={this.mapReady}>
                        <Marker name={this.state.poi.nombre} onClick={this.onMarkerClick}/>
                        <InfoWindow marker={this.state.activeMarker} visible={this.state.showingMarker}
                                    onClose={this.onInfoWindowClose}>
                            <div>
                                <h4>{this.state.poi.nombre}</h4>
                                <p>{this.state.poi.direccion}</p>
                            </div>
                        </InfoWindow>
                    </Map>
                </div>
            )
        }
        return <Vacio />
    }
}



// WEBPACK FOOTER //
// ./src/components/PoiMap.js